//reviews js
    $( document ).ready(function() {
      if( window.location.pathname == "/"){
        var checkExist = setInterval(function() {
          if ($('.carousel-footer--3otcf').length) {
            $('.carousel-footer--3otcf').hide();
            var review =$(".carousel-footer--3otcf").html()
            $('.reviews-holder--3hf8N').prepend('<div class="carousel-footer--3otcf">' + review + '</div></div>')
             clearInterval(checkExist);
          }
       }, 100);
      }
    });